import { Pipe, PipeTransform } from '@angular/core';
import { HireItemAttachmentStage } from '../../models/HireItemAttachment';

@Pipe({
    name: 'hireItemAttachmentStage',
    standalone: true
})
export class HireItemAttachmentStagePipe implements PipeTransform {
  transform(value: HireItemAttachmentStage): string {
    return {
      on_hire: 'On Hire',
      off_hire: 'Off Hire',
      during_hire: 'During Hire',
      delivery: 'Delivery',
      collection: 'Collection'
    }[value];
  }
}
